import React, { Component } from 'react';
import __ from 'lodash';
import {Col, Form} from 'react-bootstrap';
import SoalAkmReq from '../../../../entity/SoalAkmReq';
import { CONFIG,URL_AKM } from '../../../../config';
import { metadataApi as akmApi } from '../../../../apis/indicatorApi';

class SoalBenarSalah extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            soal: this.props.soal,
            soalDetailAkm: []
        }
    }

    async componentDidMount() {        
        if(this.props.soal.idBankSoal){
            this.fetchSoalDetailAkm();
        }
        (function()
        {
          if( window.localStorage )
          {
            if( !localStorage.getItem('firstLoad') )
            {
              localStorage['firstLoad'] = true;
              window.location.reload();
            }  
            else
              localStorage.removeItem('firstLoad');
          }
        })();
    }

    async fetchSoalDetailAkm() {
        this.setState({ soalDetailAkm: []})
        const response = await akmApi.get(URL_AKM.GET_SOAL_DETAIL_AKM_BY_IDBANKSOAL + this.props.soal.idBankSoal)
        .catch(function(error){ alert(error) })
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    soalDetailAkm: response.data.data
                })
                this.props.addSoalDetailAkm(response.data.data);
            } 
        }
    }
   
    handlePernyataan(i,event) {
        let array = [...this.state.soalDetailAkm];
        array[i] = {...array[i], pernyataan: event.target.value};
        this.setState({ soalDetailAkm: array})
        this.props.addSoalDetailAkm(array);
    }
    handleKunciJawaban(i,event) {
        let array = [...this.state.soalDetailAkm];
        array[i] = {...array[i], kunciJawaban: event.target.value};
        this.setState({ soalDetailAkm: array})
        this.props.addSoalDetailAkm(array);
    }

    addDetail() {
        this.setState(prevState => ({ soalDetailAkm: [...prevState.soalDetailAkm, {...SoalAkmReq, kunciJawaban: '1', idBankSoal : this.state.soal.idBankSoal || null} ]}), () => this.props.addSoalDetailAkm(this.state.soalDetailAkm))
    }

    removeDetail(i) {        
        let array = [...this.state.soalDetailAkm];
        array.splice(i,1);
        this.setState({ soalDetailAkm: array})
        this.props.addSoalDetailAkm(array);
    }
    
    render() { 
        return (  
            <div className="content ">
            <Col sm={12}>                                 
                <Form.Group controlId="pertanyaan">
                    <Form.Label><h6>Pertanyaan: </h6></Form.Label>                        
                    <textarea className="tinymce_textarea" id="pertanyaan" value={this.state.soal.pertanyaan} required></textarea>    
                </Form.Group>               
                
                <Form.Group controlId="pernyataan">  
                <div class="card">
                    <div class="card-header"><button className="btn btn-outline-info" style={{width: '100%'}} onClick={() => this.addDetail()}><i className="fa fa-plus"></i>&nbsp;Tambah Pernyataan</button></div>
                    
                    <div class="card-body">
                        <table width="100%">    
                            <thead>
                                <th>No.</th>
                                <th>Pernyataan</th>
                                <th className="text-center">Jawaban</th>
                                <th></th>
                            </thead>                       
                            <tbody id="tbody">   
                                {this.state.soalDetailAkm.map((item,i) => 
                                <tr key={i}>
                                    <td width="5%">{i+1}.</td>
                                    <td><textarea className="form-control" value={item.pernyataan||''} onChange={this.handlePernyataan.bind(this,i)} required></textarea></td>
                                    <td width="10%" className="text-center"><select value={item.kunciJawaban} onChange={this.handleKunciJawaban.bind(this,i)} required><option value="1">Benar</option>
                                                <option value="0">Salah</option>
                                        </select>
                                    </td>
                                    <td width="1%"><button className="btn btn-outline-danger btn-sm" style={{width: '100%'}} onClick={this.removeDetail.bind(this,i)}><i className="fa fa-remove"></i></button></td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                         
                    </div> 
                </div>
                </Form.Group>  

                <Form.Group controlId="pembahasan">
                    <Form.Label><h6>Pembahasan: </h6></Form.Label>                        
                    <textarea className="tinymce_textarea" id="pembahasan" value={this.state.soal.isianJawaban||''} required></textarea>    
                </Form.Group>

            </Col> 
            </div>
        );
    }
}
 
export default SoalBenarSalah;
